<template lang="pug">
    .preorder-product.container(v-observe-visibility="{ callback: visibilityChanged, once: true }")
        .info
            .name
                 router-link(:to="{ name: 'product-details', params: { product: product.slug }}") {{ product.name }}
            .nr Artikel-Nr.: {{ product.nr }}
            //- .media
                .active-media(v-if="activeMedia && mediaWidth")
                    FullImage(
                        v-if="activeMedia.type === 'image'"
                        :key="`main-${activeMedia.id}`"
                        :media="activeMedia"
                        :product="product"
                        :preferred-width="mediaWidth"
                    )
            .price
                nobr.font-black(:class="{ strikethrough: salePrice }") {{ price }}
                nobr.sale(v-if="salePrice") {{ salePrice }}
            .total
                .price(v-if="total")
                    span.label Gesamt:
                    span.value {{ total | moneyFormat(currency) }}
        Preorder(
            v-if="product != undefined"
            :valid="valid"
            :article-properties="articleProperties"
            :product-properties="configurableProductProperties"
            :articles="product.articles || articles"
            :valid-articles="validArticles"
            :selected-options="selectedOptions"
            :manage-stock="product.manage_stock"
            :total.sync="total"
            @select-property="selectPropertyOption"
            @toggle-active-article="toggleActiveArticle"
        )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { get } from '@/helpers';

import product from '@/extensions/shop/mixins/product';

export default {
    name: 'PreorderProduct',
    mixins: [product],
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        mediaWidth: 30,
        articles: [],
        total: 0
    }),
    computed: {
        ...mapGetters({
            cms: 'CMS'
        })
    },
    methods: {
        async visibilityChanged(visible) {
            if (visible && this.product.articles == null) {
                const shop = get(this.cms, 'shop.id');
                this.articles = await this.fetchArticles({
                    product: parseInt(this.product.id),
                    shop: parseInt(shop)
                });
                // this.product.articles = articles
                // this.$set(this.product, 'articles', articles)
            }
        },
        ...mapActions({
            fetchArticles: 'shop/fetchArticles'
        })
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.preorder-product
  @screen md
    @apply mx-auto

.info
    display: grid
    grid-template-rows: 1.5rem auto
    grid-template-columns: max-content max-content auto max-content
    column-gap: 2rem
    margin-bottom: 1rem
.name, .price, .total
    font-weight: bold
    grid-row: 1
.media
    grid-row: 1 / 3
    ::v-deep figure
      border-radius: 4px

.price
  position: relative
  span.label
    font-weight: normal
    &:after
      content: ' '
.price nobr + nobr.sale
  margin-left: 1rem
  color: theme('colors.gray.700')
  position: relative
  z-index: 1
  &:before
    content: ''
    position: absolute
    // background-color: theme('colors.red.100')
    background-color: #e6ff15
    width: calc(100% + 8px)
    height: calc(100% + 4px)
    left: -4px
    top: -7px
    z-index: -1
    transform: rotate(-9deg) skew(-2deg, 0deg)
</style>
